const widResult = [
  {
    wid: '00',
    weather: '晴',
    icon: 'icontianqi3',
  },
  {
    wid: '01',
    weather: '多云',
    icon: 'iconsvg-',
  },
  {
    wid: '02',
    weather: '阴',
    icon: 'icontianqi-yin',
  },
  {
    wid: '03',
    weather: '阵雨',
    icon: 'iconzhenyu2',
  },
  {
    wid: '04',
    weather: '雷阵雨',
    icon: 'icontianqi4',
  },
  {
    wid: '05',
    weather: '雷阵雨伴有冰雹',
    icon: 'iconbingbao2',
  },
  {
    wid: '06',
    weather: '雨夹雪',
    icon: 'icontianqi-yujiaxue',
  },
  {
    wid: '07',
    weather: '小雨',
    icon: 'icontianqi-xiaoyu',
  },
  {
    wid: '08',
    weather: '中雨',
    icon: 'icontianqi-zhongyu',
  },
  {
    wid: '09',
    weather: '大雨',
    icon: 'icontianqi-dayu',
  },
  {
    wid: '10',
    weather: '暴雨',
    icon: 'iconbaoyu',
  },
  {
    wid: '11',
    weather: '大暴雨',
    icon: 'icondabaoyu1',
  },
  {
    wid: '12',
    weather: '特大暴雨',
    icon: 'icontedabaoyu',
  },
  {
    wid: '13',
    weather: '阵雪',
    icon: 'iconzhenxue2',
  },
  {
    wid: '14',
    weather: '小雪',
    icon: 'icontianqi-xiaoxue',
  },
  {
    wid: '15',
    weather: '中雪',
    icon: 'iconzhongxue1',
  },
  {
    wid: '16',
    weather: '大雪',
    icon: 'icondaxue1',
  },
  {
    wid: '17',
    weather: '暴雪',
    icon: 'iconbaoxue1',
  },
  {
    wid: '18',
    weather: '雾',
    icon: 'icontianqi-wu',
  },
  {
    wid: '19',
    weather: '冻雨',
    icon: 'icondongyu',
  },
  {
    wid: '20',
    weather: '沙尘暴',
    icon: 'iconshachengbao',
  },
  {
    wid: '21',
    weather: '小到中雨',
    icon: 'icontianqi-zhongyu',
  },
  {
    wid: '22',
    weather: '中到大雨',
    icon: 'icontianqi-dayu',
  },
  {
    wid: '23',
    weather: '大到暴雨',
    icon: 'iconbaoyu',
  },
  {
    wid: '24',
    weather: '暴雨到大暴雨',
    icon: 'icondabaoyu1',
  },
  {
    wid: '25',
    weather: '大暴雨到特大暴雨',
    icon: 'icontedabaoyu',
  },
  {
    wid: '26',
    weather: '小到中雪',
    icon: 'iconzhongxue1',
  },
  {
    wid: '27',
    weather: '中到大雪',
    icon: 'icondaxue1',
  },
  {
    wid: '28',
    weather: '大到暴雪',
    icon: 'iconbaoxue1',
  },
  {
    wid: '29',
    weather: '浮尘',
    icon: 'iconfuchen6',
  },
  {
    wid: '30',
    weather: '扬沙',
    icon: 'iconyangsha1',
  },
  {
    wid: '31',
    weather: '强沙尘暴',
    icon: 'iconicon-severeSandStorm',
  },
  {
    wid: '53',
    weather: '霾',
    icon: 'iconwumai',
  },
];

const aqiResult = [
  {
    aqi: [0, 50],
    text: '优',
    color: '#40C157',
  },
  {
    aqi: [51, 100],
    text: '良',
    color: '#FFA769',
  },
  {
    aqi: [101, 150],
    text: '轻度',
    color: '#FF8620',
  },
  {
    aqi: [151, 200],
    text: '中度',
    color: '#FF5066',
  },
  {
    aqi: [201, 300],
    text: '重度',
    color: '#B3002F',
  },
  {
    aqi: [301, 10000],
    text: '严重',
    color: '#6A0000',
  },
];

const widIcons = widResult.reduce((res, cur) => {
  res[cur.wid] = cur.icon;
  return res;
}, {});

const widWeather = widResult.reduce((res, cur) => {
  res[cur.wid] = cur.weather;
  return res;
}, {});

export { widResult, aqiResult, widIcons, widWeather };
